/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  // Create a WhatsApp message template (submitted to Meta for approval).
  createWhatsappTemplate(inboxId, payload) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, payload);
  }

  // Upload a header/carousel image and return its Meta upload handle.
  uploadWhatsappTemplateMedia(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

export default new Inboxes();
